import { render } from "./RecordForm.vue?vue&type=template&id=5cfbda1f&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"

import "./RecordForm.vue?vue&type=style&index=0&id=5cfbda1f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfbda1f"]])

export default __exports__